<template>
  <!--重新编号页面-->
  <div class="main">

    <a-card class="box-card">

      <div class="button-sj0">
        <span class="kalami">用户选择:</span>
        <a-select placeholder="请选择用户" @change="getdblist" v-model="phone" class="select-sj">
          <a-select-option v-for="(item, index) in userlist" :key="index" :value="item.phone">
            {{ item.userName }} {{ item.phone }}
          </a-select-option>
        </a-select>
      </div>



      <div class="button-sj">
        <span class="kalami">采集项目名称:</span>
        <a-select 
          v-model="selectedProjectId" 
          placeholder="请选择DB文件" 
          class="select-sj"
          @change="handleProjectChange"
        >
          <a-select-option 
            v-for="item in dblist" 
            :key="item.id" 
            :value="item.id"
          >
            {{ item.projectName }}
          </a-select-option>
        </a-select>
        <a-button type="primary" @click="pointlist" style="margin-left: 15px;margin-top: -2px;"  v-action:edit>重新编号</a-button>
      </div>

      <!--重新编号弹窗-->
      <a-modal title="重新编号" :visible.sync="PreviewResultsDigital" width="35%" :footer="null" @cancel="handleCancel">
        <div style="font-weight: bolder;">参数设置</div>
        <div style="margin:20px 0 10px 24px">当前项目：{{ project.projectName }}</div>
        <div style="padding: 10px 24px;background-color: #ededed;">
          <p>样式：JS1 → <span style="font-weight: bold;">JS + 组号 + 虚拟号 </span> → JS100001</p>
          <div style="display: flex;align-items: center;">
            <span class="bt">组号：</span><a-input-number v-model="groupNumber" :min="1" :max="999"
              style="margin-right: 5px;" />
            虚拟数：<a-input-number v-model="vacantPosition" :min="1" :max="5" style="margin-right: 5px;" />
            虚拟生成：<a-input style="width: 100px;" v-model="scvacantPosition" :disabled="true" />
          </div>
        </div>
        <div class="preview-btn-wrapper">
          <a-button 
            type="primary" 
            @click="cxbh" 
            style="background-color: #1890FF;border-color: #1890FF"
            :loading="previewLoading"
          >
            {{previewLoading ? '加载中...' : '查看结果预览'}}
          </a-button>
        </div>
        <div class="title">匹配后结果预览</div>
        <a-table :scroll="{ y: 200 }" :dataSource="dataSource" :bordered="true" :columns="columns"
          :pagination="false" />
       
        <div class="footer-btns">
          <a-button @click="handleCancel">取消</a-button>
          <a-button 
            type="primary" 
            @click="submit" 
            v-if="issubmit" 
            :loading="submitLoading"
            style="background-color: #1890FF;border-color: #1890FF"
          >
            {{submitLoading ? '编号中...' : '重新编号'}}
          </a-button>
        </div>
      </a-modal>

      <a-modal :visible.sync="coordinateDialogVisible" width="20%" @cancel="coordinateDialogVisible = false"
        @ok="renumber">

        <div class="gth">
          <div> <img src="@/assets/collectionMappingSystem/gth.png" style="width: 25px;height: 25px;margin-right: 10px;" />
          </div>
          <span style="font-weight: bold;font-size: 16px;">请注意</span>

        </div>
        <div style="text-align: center;margin: 50px 0;">是否确定要进行重新编号?</div>

      </a-modal>

      <!-- 添加加载动画组件 -->
      <loading-spinner 
        :visible="submitting" 
        :is-success="loadingSpinnerSuccess"
        text="写入数据中"
      />

      <!-- 添加物探点号详情弹窗 -->
      <a-modal 
        title="物探点详情" 
        :visible.sync="detailVisible" 
        width="45%" 
        @cancel="handleDetailCancel"
        :footer="null"
      >
        <a-table 
          :columns="detailColumns"
          :dataSource="detailData"
          :pagination="detailPagination"
          :bordered="true"
          @change="handleDetailTableChange"
        />
      </a-modal>
    </a-card>

    <!-- 重新编号项目列表卡片 -->
    <a-card class="list-card" title="已重新编号历史记录">
      <!-- 查询条件 -->
      <div class="search-form">
        <a-form layout="inline">
          <a-form-item label="用户选择">
            <a-select 
              v-model="searchForm.phone" 
              placeholder="请选择用户" 
              class="select-width"
              allowClear
              @change="handleUserChange"
            >
              <a-select-option v-for="(item, index) in userlist" :key="index" :value="item.phone">
                {{ item.userName }} {{ item.phone }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="项目名称">
            <a-input v-model="searchForm.projectName" placeholder="请输入项目名称" allowClear />
          </a-form-item>
          <a-form-item label="采集单位">
            <a-input v-model="searchForm.acquisitionUnits" placeholder="请输入采集单位" allowClear />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleSearch">查询</a-button>
            <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>

      <!-- 列表内容 -->
      <a-table
        :columns="listColumns"
        :dataSource="renumberList"
        :pagination="pagination"
        @change="handleTableChange"
        :rowKey="record => record.id"
        bordered
      >
        <template slot="projectCategory" slot-scope="text">
          {{ getProjectType(text) }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="showDetail(record)">查看详情</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const columns = [
  {
    title: '物探点号',
    dataIndex: 'intuitionPoint',
    align: 'center',
    width: 120,

  }, {
    title: '变换后',
    width: 100,
    dataIndex: 'afterTheChange', align: 'center',
  }
]

export default {
  name: 'CoordinateMatching',
  components: {
    LoadingSpinner
  },
  data () {
    return {
      columns,
      PreviewResultsDigital: false,
      coordinateDialogVisible: false,
      phone: '',
      userlist: [],
      dblist: [],
      dataSource: [],
      groupNumber: null,
      vacantPosition: '',
      scvacantPosition: '',
      project: {
        projectName: '',
        id: ''
      },
      queryuserUrl: '/gis-manager/user/deploy/user/list/2',
      issubmit: false,
      selectedProjectId: undefined,
      submitting: false,
      loadingSpinnerSuccess: false,
      listColumns: [
        { title: '序号', dataIndex: 'index', width: 80 },
        { title: '用户名称', dataIndex: 'userName' },
        { title: '手机号码', dataIndex: 'phone' },
        { title: '采集项目名称', dataIndex: 'projectName' },
        { 
          title: '采集项目类型', 
          dataIndex: 'projectCategory',
          scopedSlots: { customRender: 'projectCategory' }
        },
        { title: '采集单位', dataIndex: 'acquisitionUnits' },
        { title: '作业小组', dataIndex: 'assignmentGroup' },
        { title: '负责人', dataIndex: 'responsiblePerson' },
        { title: '组号', dataIndex: 'groupNumber' },
        { title: '虚位数', dataIndex: 'virtualDigitNumber' },
        { title: '重新编号时间', dataIndex: 'updateTime' },
        { title: '操作', scopedSlots: { customRender: 'operation' } }
      ],
      detailColumns: [
        { title: '物探点号(编号前)', dataIndex: 'intuitionPoint', width: 150 },
        { title: '物探点号(编号后)', dataIndex: 'afterTheChange', width: 150 },
        { title: '组号', dataIndex: 'groupNumber', width: 150 },
        { title: '虚位数', dataIndex: 'vacantPosition', width: 150 },
        { title: '更新时间', dataIndex: 'updateTime', width: 180 }
      ],
      renumberList: [],
      detailData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '30', '50']
      },
      detailPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '30', '50']
      },
      detailVisible: false,
      searchForm: {
        phone: '',
        projectName: '',
        acquisitionUnits: ''
      },
      projectTypes: {
        1: '给水',
        2: '排水',
        3: '燃气',
        4: '热力'
      },
      currentDetailRecord: null,
      previewLoading: false,
      submitLoading: false,
    }
  },
  watch: {
    vacantPosition (n) {
      let num = '1' + '0'.repeat(n)
      this.scvacantPosition = num.substring(1)
    }
  },
  computed: {

  },
  created () {
    this.getUserlist()
    this.fetchRenumberList()
  },
  methods: {
    getUserlist () {
      this.$http.get(this.queryuserUrl).then((res) => {
        this.userlist = res.data
      })
    },
    getdblist () {
      if (!this.phone) return
      
      // 重置DB文件选择
      this.selectedProjectId = undefined
      this.project = {
        projectName: '',
        id: ''
      }
      this.dataSource = []
      this.PreviewResultsDigital = false
      this.issubmit = false
      this.groupNumber = null
      this.vacantPosition = ''
      this.scvacantPosition = ''
      
      this.$http.get('/gis-manager/diagramming/project/list/items/' + this.phone+'/2').then((res) => {
        if (res.code === 0) {
          this.dblist = res.data || []
          this.project = {
            projectName: '',
            id: ''
          }
        } else {
          this.$message.error(res.message || '获取DB文件列表失败')
        }
      }).catch(error => {
        console.error('获取DB文件列表失败:', error)
        this.$message.error('获取DB文件列表失败')
      })
    },
    handleProjectChange(id) {
      this.selectedProjectId = id
      const selectedProject = this.dblist.find(item => item.id === id)
      if (selectedProject) {
        this.project = {
          projectName: selectedProject.projectName,
          id: selectedProject.id
        }
      }
    },
    pointlist () {
      if (!this.project) {
        this.$message.error('请选择DB文件！')
        return
      }
      this.$http.get('/gis-manager/diagramming/point/list?projectManagementId=' + this.project.id)
        .then((res) => {
          if (res.code === 0) {
            this.dataSource = res.data
            this.PreviewResultsDigital = true
          } else {
            this.$message.error(res.message || '获取点列表失败')
          }
        })
        .catch(error => {
          console.error('获取点列表失败:', error)
          this.$message.error('获取点列表失败')
        })
    },
    cxbh () {
      if (!this.groupNumber) {
        this.$message.error('请填写组号！')
        return
      }
      this.previewLoading = true
      this.renumber()
    },
    renumber () {
      this.$http.post('/gis-manager/pipeline/point/renumber', {
        projectManagementId: this.project.id,
        groupNumber: this.groupNumber,
        vacantPosition: this.scvacantPosition
      }).then((res) => {
        if (res.code === 0) {
          this.dataSource = res.data
          this.coordinateDialogVisible = false
          this.issubmit = true
          this.$message.success('预览成功')
        } else {
          this.$message.error(res.message || '预览失败')
        }
      }).catch(error => {
        console.error('预览失败:', error)
        this.$message.error('预览失败，请重试')
      }).finally(() => {
        this.previewLoading = false
      })
    },
    submit () {
      this.submitLoading = true
      this.$http.post('/gis-manager/pipeline/point/renumber/save', this.dataSource)
        .then((res) => {
          if (res.code === 0) {
            this.loadingSpinnerSuccess = true
            this.$message.success('重新编号成功')
            setTimeout(() => {
              this.submitting = false
              this.issubmit = false
              this.loadingSpinnerSuccess = false
              this.PreviewResultsDigital = false
            }, 1000)
            this.fetchRenumberList()
          } else {
            this.$message.error(res.message || '重新编号失败')
          }
        })
        .catch(error => {
          console.error('重新编号失败:', error)
          this.$message.error('重新编号失败，请重试')
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    handleCancel () {
      this.PreviewResultsDigital = false
      this.coordinateDialogVisible = false
      this.issubmit = false
    },
    fetchRenumberList() {
      const params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        ...this.searchForm
      }
      this.$http.get('/gis-manager/diagramming/project/renumber/page', { params })
        .then(res => {
          if (res.code === 0) {
            this.renumberList = res.data.list.map((item, index) => ({
              ...item,
              index: (this.pagination.current - 1) * this.pagination.pageSize + index + 1
            }))
            this.pagination.total =Number(res.data.total)
          }
        })
    },
    showDetail(record) {
      this.detailVisible = true
      this.currentDetailRecord = record
      this.fetchDetailList()
    },
    fetchDetailList() {
      const params = {
        page: this.detailPagination.current,
        limit: this.detailPagination.pageSize,
        projectManagementId: this.currentDetailRecord?.id
      }
      
      this.$http.get('/gis-manager/diagramming/project/point/renumber/page', { params })
        .then(res => {
          if (res.code === 0) {
            this.detailData = res.data.list
            this.detailPagination.total = Number(res.data.total)
          }
        })
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchRenumberList()
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchRenumberList()
    },
    handleReset() {
      this.searchForm = {
        phone: '',
        projectName: '',
        acquisitionUnits: ''
      }
      this.handleSearch()
    },
    handleUserChange(value) {
      this.searchForm.phone = value
      this.handleSearch()
    },
    getProjectType(type) {
      return this.projectTypes[type] || '未知'
    },
    handleDetailCancel() {
      this.detailVisible = false
      this.currentDetailRecord = null
      this.detailPagination.current = 1
      this.detailData = []
    },
    handleDetailTableChange(pagination, filters, sorter) {
      this.detailPagination = { ...this.detailPagination, ...pagination }
      this.fetchDetailList()
    }
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  /deep/ .ant-card-bordered{
    border:none;
  }
}

.kalami {
  margin-right: 10px;
  font-family: 微软雅黑;
  font-size: 16px;
  width: 113px;
  display: inline-block;
  text-align: right;
}

.box-card {
  height: auto;
  padding: 20px;
  margin-bottom: 20px;
}

.button-sj {
  margin-top: 20px;
}

.button-sj0 {
  margin-bottom: 20px;
}

.select-sj {
  width: 500px;
}

.title {
  font-weight: bold;
  margin: 20px 0 15px 0;
}

.bt:before {
  content: '* ';
  color: red;
}

.list-card {
  .search-form {
    margin-bottom: 20px;
    padding: 24px;
     border-radius: 4px;
  }
}

.select-width {
  width: 250px;
}

.gth {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.preview-btn-wrapper {
  text-align: center;
  margin: 10px 0;
}

.footer-btns {
  text-align: right;
  margin-top: 16px;
  padding-right: 8px;

  .ant-btn {
    margin-left: 8px;
  }
}
</style>
